import { render } from "./CreateConfiguration.vue?vue&type=template&id=7aca37ca&scoped=true"
import script from "./CreateConfiguration.vue?vue&type=script&lang=js"
export * from "./CreateConfiguration.vue?vue&type=script&lang=js"

import "./CreateConfiguration.vue?vue&type=style&index=0&id=7aca37ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aca37ca"]])

export default __exports__